export default __webpack_public_path__ + "static/media/AccountPlaceholder.e7d54015.png";